import ActionsGenerator from '../../lib/ActionsGenerator'

const generator = new ActionsGenerator('rates_batch', '/rates_batches')
const actions = generator.generate()

export default actions
